import React from 'react';
import { Link } from 'react-router-dom';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import { formatNumber } from '../../../lib/utils';

export default class CampaignListsTableRow extends NavigationComponent {

    render() {
        const { campaignListId, name, locationName, count, fundName, batch } = this.props.campaignList;
        return (
            <HoverTableRow onClick={this.pushRoute.bind(this, `/campaigns/lists/${campaignListId}`)}>
                <td data-label="Name">
                    <Link
                        className="bold-text flex flex-center"
                        to={`/campaigns/lists/${campaignListId}`}>
                        {name}{batch && <i className="material-icons ml-16 medium-text">filter_none</i>}  
                    </Link>
                </td>
                <td data-label="City">
                    <p>{locationName}</p>
                </td>
                <td data-label="People">
                    <p>{formatNumber(count)}</p>
                </td>
                <td data-label="Fund">
                    <p>{fundName}</p>
                </td>
            </HoverTableRow>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignLists/CampaignListsTableRow.jsx